const apiErrors = {
  emailexists: {
    message: 'Пользователь с заданной электронной почтой уже есть в системе.'
  },
};

export default apiErrors;
